import api from "./api";

/**
 * @description Servicio para gestión de roles y permisos
 */
const roleService = {};
const endpoint = "/roles";

/**
 * @description Obtiene todos los roles con sus permisos
 * @returns {Promise<Array>} Lista de roles con sus permisos
 */
roleService.getRoles = function () {
  return api.get(endpoint).then((res) => res.data);
};

/**
 * @description Obtiene todos los permisos disponibles
 * @returns {Promise<Array>} Lista de todos los permisos
 */
roleService.getPermissions = function () {
  return api.get(`${endpoint}/permissions`).then((res) => res.data);
};

/**
 * @description Actualiza los permisos de un rol
 * @param {string} roleId - ID del rol
 * @param {Array<string>} permissions - Array de IDs de permisos
 * @returns {Promise<Object>} Rol actualizado
 */
roleService.updatePermissions = function (roleId, permissions) {
  return api
    .put(`${endpoint}/${roleId}/permissions`, { permissions })
    .then((res) => res.data);
};

export default roleService;
